import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";

function Navbar() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="navbar-wrapper">
      <div className={`navbar-container ${menuOpen ? "menu-open" : ""}`}>

        <div className="logo">RDS Technology</div>

        <div
          className={`menu-toggle ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        <nav className={`nav-links ${menuOpen ? "active" : ""}`}>
          <Link onClick={() => setMenuOpen(false)} className={location.pathname === "/" ? "active" : ""} to="/">Home</Link>
          <Link onClick={() => setMenuOpen(false)} className={location.pathname === "/about" ? "active" : ""} to="/about">About</Link>
          <Link onClick={() => setMenuOpen(false)} className={location.pathname === "/services" ? "active" : ""} to="/services">Services</Link>
          <Link onClick={() => setMenuOpen(false)} className={location.pathname === "/projects" ? "active" : ""} to="/projects">Portfolio</Link>
          <Link onClick={() => setMenuOpen(false)} className={location.pathname === "/career" ? "active" : ""} to="/career">Career</Link>
          <Link onClick={() => setMenuOpen(false)} className={location.pathname === "/contact" ? "active" : ""} to="/contact">Contact</Link>
        </nav>

      </div>
    </div>
  );
}

export default Navbar;
